$(function () {
  if ($("#uber").hasClass("interior")) {
    // Add class to uber if calendar template
    if ($("#CalendarTemplate").length > 0) {
      $("#uber").addClass("calendarView");
    }
  }
});